// ─────────────────────────────────────────────────────────────────
// Glass-i — Glass Category Master API client (Stage 6B.8A-3N).
//
// Thin axios wrappers around /api/erp/masters/glass-categories/*.
// The inline-CRUD page uses `list` to load the grid and `bulkSave`
// to persist all dirty rows + queued deletes in one round-trip.
//
// `lookups` powers the Item-create Category dropdown — it returns
// id+sno+categoryName+glassFamily+glassColor so the modal can
// stash the family/color onto the form values directly without
// asking the helper to consult a hardcoded table.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/glass-categories';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const glassCategoryApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups:  (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  get:      (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:   (payload)     => client.post(BASE, payload).then(unwrap),
  update:   (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:   (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  reorder:  (payload)     => client.post(`${BASE}/reorder`, payload).then(unwrap),
  bulkSave: (payload)     => client.post(`${BASE}/bulk-save`, payload).then(unwrap)
};

// Convenience for callers (CreateGlassModal) that just need the
// lookup with soft-fail — returns null on any network / 4xx error
// so the caller can fall back to its frozen DEFAULT_GLASS_CATEGORIES.
export async function loadGlassCategoryLookupsSafe() {
  try { return await glassCategoryApi.lookups(); }
  catch (_e) { return null; }
}

export default glassCategoryApi;
